/*
 * Proprietary and confidential | 2026 | SoundTalks NV
 */

import appConfig from 'config';

const configFeatures = appConfig?.features ?? {};

// TODO: https://gitlab.soundtalks.com/groups/IT/-/epics/117 - features disabled for inventory management.
export const SOURCE_FIELDS_ENABLED = configFeatures.SOURCE_FIELDS_ENABLED ?? true;
export const STOCK_CHOICE_POPUP_ENABLED = configFeatures.STOCK_CHOICE_POPUP_ENABLED ?? true;
export const INCLUDE_ORIGIN_IN_PAYLOAD = configFeatures.INCLUDE_ORIGIN_IN_PAYLOAD ?? true;
